export default "__VITE_ASSET__qgiXHYVa__"